module.exports = __webpack_public_path__ + "static/media/Meniaga_APPS-SS02@2x.c851c8ef.png";